<template>
  <div class="increase-edit-padding">
    <a-spin :spinning="loading">
      <a-skeleton v-show="loading" :paragraph="{rows: 10}" />
    </a-spin>
    <div v-show="!loading">
      <!-- 表单 -->
      <a-form :form="editForm" @submit="handleSubmit" autocomplete="off">
        <!-- 代码 -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Code"
        >
          <a-input
            placeholder="Code"
            v-decorator="[
              'code',
              {rules: [{ required: true, message: 'Please input Code.' }]}
            ]"
          ></a-input>
        </a-form-item>
        <!-- 名称-英文美国 -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Name(en-us)"
        >
          <a-input
            placeholder="Name(en-us)"
            v-decorator="[
              'nameEnUs',
              {rules: [{ required: true, message: 'Please input Name.' }]}
            ]"
          ></a-input>
        </a-form-item>
        <!-- 名称-中文繁体 -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Name(zh-tw)"
        >
          <a-input
            placeholder="Name(zh-tw)"
            v-decorator="[
              'nameZhTw',
              {rules: [{ required: false, message: 'Please input Name.' }]}
            ]"
          ></a-input>
        </a-form-item>
        <!-- 名称-中文简体 -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Name(zh-cn)"
        >
          <a-input
            placeholder="Name(zh-cn)"
            v-decorator="[
              'nameZhCn',
              {rules: [{ required: false, message: 'Please input Name.' }]}
            ]"
          ></a-input>
        </a-form-item>
        <!-- 启用标志 -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Eabled"
        >
          <a-switch
            v-decorator="[
              'enabledFlag',
              { valuePropName: 'checked' }
            ]"
          ></a-switch>
        </a-form-item>
        <!-- 隐藏域 -->
        <a-form-item v-show="false"><a-input v-decorator="['id']"/></a-form-item>
        <!-- 按钮 -->
        <a-form-item v-bind="buttonCol">
          <a-row class="btn-box" style="padding-left: 12.5%;">
            <a-button type="primary" html-type="submit" :loading="saving" @click="handleSubmit">Save</a-button>
            <a-button style="margin-left: 8px;" :loading="saving" @click="handleGoBack">Cancel</a-button>
          </a-row>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import pick from 'lodash.pick'
import CurrencyApi from '@/api/basicdata/api-currency'
import FooterToolBar from '@/components/FooterToolbar'

export default {
  name: 'CurrencyEdit',
  components: {
    FooterToolBar
  },
  props: {
    record: {
      type: [String, Object],
      default: null
    }
  },
  data () {
    return {
      saving: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 3 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 24 }
        }
      },
      editForm: this.$form.createForm(this),
      createFlag: false,
      // 加载中
      loading: true
    }
  },
  mounted () {
    this.initData(this.record)
  },
  methods: {
    async initData (data) {
      this.loading = true
      var formData = null
      var createFlag = true
      if (data === '') {
        // 新增
        formData = { 'id': null, 'code': null, 'nameEnUs': null, 'nameZhTw': null, 'nameZhCn': null, 'enabledFlag': true }
      } else {
        createFlag = false
        // 编辑
        formData = pick(data, ['id', 'code', 'nameEnUs', 'nameZhTw', 'nameZhCn', 'enabledFlag'])
        if (formData.enabledFlag !== null && formData.enabledFlag === '1') {
          formData.enabledFlag = true
        } else {
          formData.enabledFlag = false
        }
      }
      this.createFlag = createFlag
      this.editForm.setFieldsValue(formData)
      this.loading = false
    },
    loadAllDeptList () {
      return CurrencyApi.query(Object.assign({ curPage: 1, pageSize: 1000 }, {}))
    },
    handleGoBack () {
      this.$emit('onGoBack')
    },
    handleSubmit (e) {
      e.preventDefault()
      this.saving = true
      this.editForm.validateFields((err) => {
        // 如果校验失败直接返回
        if (err) {
          return
        }
        var formData = this.editForm.getFieldsValue()
        formData.enabledFlag = formData.enabledFlag ? '1' : '0'
        // 添加
        if (formData.id === null) {
          CurrencyApi.add(formData).then(res => {
            if (!this.mixinProcessHasBizErrorNotification(res)) {
              this.mixinProcessSuccessNotification('Save successfully !')
              this.handleGoBack()
            }
          }).finally(() => {
            this.saving = false
          })
        }
        // 修改
        if (formData.id !== null) {
          CurrencyApi.update(formData.id, formData).then(res => {
            if (!this.mixinProcessHasBizErrorNotification(res)) {
              this.mixinProcessSuccessNotification('Update successfully !')
              this.handleGoBack()
            }
          }).finally(() => {
            this.saving = false
          })
        }
      })
    }
  }
}
</script>
